export default "__VITE_ASSET__bb45af52__"